import { IJsonQuery } from '@cian/api-models/common/json_query';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import { DEAL_TYPE_NAMES } from '../../constants/dealType';
import { FDealType, dealTypeFromJsonQuery } from '../../utils/category';
import { ESpecialType, trackDealTypeTabClick, trackSpecialTabClick } from './tracking';
import * as styles from './FiltersTabs.css';

export interface IFiltersTabsProps {
  jsonQuery: IJsonQuery;
  onDealTypeSelect(dealType: FDealType): void;
}

const DEAL_TYPES: { label: string; url: string; value: FDealType }[] = [
  { label: DEAL_TYPE_NAMES[FDealType.Sale], url: '/kupit/', value: FDealType.Sale },
  { label: DEAL_TYPE_NAMES[FDealType.RentLongterm], url: '/snyat/', value: FDealType.RentLongterm },
  { label: DEAL_TYPE_NAMES[FDealType.RentDaily], url: '/posutochno/', value: FDealType.RentDaily },
];

const SPECIAL_TYPES: { label: string; url: string; value: ESpecialType }[] = [
  { label: 'Оценить квартиру', url: '/kalkulator-nedvizhimosti/', value: ESpecialType.Valuation },
  // { label: 'Найти риэлтора', url: '/agents/' },
];

export class FiltersTabs extends React.Component<IFiltersTabsProps> {
  public render() {
    const { jsonQuery } = this.props;
    const dealType = dealTypeFromJsonQuery(jsonQuery);

    return (
      <ul className={styles['list']} data-mark="FiltersTabs">
        {DEAL_TYPES.map(item => (
          <li
            key={`item_${item.label}`}
            {...mergeStyles(styles['list-element'], dealType === item.value && styles['list-element--active'])}
          >
            <a href={item.url} onClick={event => this.handleDealTypeClick(event, item.value)}>
              {item.label}
            </a>
          </li>
        ))}
        {SPECIAL_TYPES.map(item => (
          <li
            key={`item_${item.label}`}
            className={styles['list-element']}
          >
            <a href={item.url} target="_blank" onClick={event => this.handleSpecialTypeClick(event, item.value)}>
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    );
  }

  private handleDealTypeClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, type: FDealType) => {
    event.preventDefault();
    this.props.onDealTypeSelect(type);
    trackDealTypeTabClick(type);
  }

  private handleSpecialTypeClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, type: ESpecialType) => {
    trackSpecialTabClick(type);
  }
}
